import React from 'react';
import { PieChart } from 'react-native-chart-kit';
import { View, Text } from 'react-native';
import LottieView from 'lottie-react-native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { MODERN_CHART_COLORS } from '@utils/chartTheme';
import ModernChartWrapper from './ModernChartWrapper';

interface UsageDistributionPieChartProps {
  data?: any;
  isLoading?: boolean;
  chartConfig?: any;
  width?: number;
  height?: number;
}

const UsageDistributionPieChart: React.FC<UsageDistributionPieChartProps> = ({
  data,
  isLoading = false,
  chartConfig,
  width = 280,
  height = 180
}) => {
  const theme = themeSelector();
  const summaryData = [
    { label: 'Storage', value: '45%', color: MODERN_CHART_COLORS.pie.primary },
    { label: 'Data', value: '35%', color: MODERN_CHART_COLORS.pie.secondary },
    { label: 'AI Calls', value: '20%', color: MODERN_CHART_COLORS.pie.tertiary }
  ];

  const loadingComponent = (
    <LottieView
      style={{ height: 150, alignSelf: 'center' }}
      source={require("@assets/animations/spin-leaf-loader.json")}
      autoPlay
      loop
    />
  );

  return (
    <ModernChartWrapper
      title="Resource Distribution"
      subtitle="Overview of resource allocation"
      isLoading={isLoading}
      loadingComponent={loadingComponent}
      summaryData={summaryData}
      minHeight={320}
      minWidth={340}
    >
      {data ? (
        <PieChart
          data={data}
          width={width}
          height={height}
          chartConfig={chartConfig}
          accessor="population"
          backgroundColor="transparent"
          paddingLeft="15"
          hasLegend={true}
        />
      ) : (
        <View style={{
          height: height,
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Text style={{ color: theme ? '#64748b' : '#94a3b8' }}>
            No distribution data available
          </Text>
        </View>
      )}
    </ModernChartWrapper>
  );
};

export default UsageDistributionPieChart;
